<template>
  <div class="vx-row">
    <div class="vx-col w-full lg:w-1/3 mb-base" v-show="$auth.checkRoles(bsgRoles.admins)">
      <admin />
    </div>
  </div>
</template>
<script>

import bsgRoles from './../roles.js'
import admin from './components/admin.vue'

export default {
  components: {
    admin
  },
  data() {
    return {
      bsgRoles
    }
  }
};
</script>